export const primary = "#f8b21f";